export default function persistUserSnapshot(user) {
  try {
    localStorage.setItem('user', JSON.stringify({ ...user, collections: {} }));
  } catch (error) {
    console.error('Failed to store user', error);
  }
}
